import { SceneItemType } from '@monorepo/types';
import React, { FunctionComponent } from 'react';
import { useVideoContext } from '../../../../hooks/use-video';
import SceneItemTitle from './scene-item-title';
import SceneVoiceoverEdit from './items/scene-voiceover/scene-voiceover-edit';
import SceneAssetEdit from './items/scene-asset/scene-asset-edit';
import { Flex, Slider, Typography } from 'antd';

import './scene-item-edit.scss';
import SceneItemDuration from './scene-item-duration';
import SceneAudioEdit from './items/scene-audio/scene-audio-edit';

const SceneItemEdit: FunctionComponent = () => {
  const { selectedScene, selectedSceneItemIndex } = useVideoContext();

  if (!selectedScene) {
    return null;
  }

  const item = selectedScene.items[selectedSceneItemIndex];

  const getItemByType = () => {
    if (item.type === SceneItemType.Asset) {
      return <SceneAssetEdit />;
    }
    if (item.type === SceneItemType.Voiceover) {
      return <SceneVoiceoverEdit />;
    }
    if (item.type === SceneItemType.Audio) {
      return <SceneAudioEdit />;
    }

    return null;
  };

  // TODO: count sum of previous scenes
  const sceneStartTime = 0 + item.start;

  return (
    <div className={'scene-item-edit'}>
      <Flex justify={'space-between'} align={'center'}>
        <SceneItemTitle item={item} />
        <div>
          <SceneItemDuration sceneItem={item} scene={selectedScene} />
        </div>
      </Flex>
      <div
        style={{
          // marginTop: '5px',
          borderTop: '1px solid #e3e3e3',
          paddingTop: '10px',
        }}
      >
        {getItemByType()}
      </div>
    </div>
  );
};

export default SceneItemEdit;
